import script from "./OutgoingComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./OutgoingComposer.vue?vue&type=script&setup=true&lang=ts"

import "./OutgoingComposer.vue?vue&type=style&index=0&id=32a9abcb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32a9abcb"]])

export default __exports__